<template>
  <div class="bgf5">
    <iHeader />
    <iNav />
    <iClassify :active="3" all-active />
    <iRightFixedBox />
    <iPageTitle :text="pageTitle" />
    <HomeAdCarousel ref="ActivityAdCarousel" class="adlist" />
    <div class="searchBox">
      <van-field v-model="formData.keyword" center placeholder="搜索当前列表产品">
        <template #button>
          <van-button size="small" type="primary" @click.stop="serchHeald()">
            <van-icon :name="require('../../assets/search-icon.png')" size="26px" style="margin-top: 3px;" />
          </van-button>
        </template>
      </van-field>
    </div>
    <div class="list">
      <div v-for="(item, index) in dataList" :key="item.Id" class="list-item">
        <!-- <product-list-item
          :ref="'p_'+item.Id"
          :product="item"
          from-page="isArriving"
          :style="{marginLeft:index % 2 == 0 ?'0px':'20px'}"
          goods-type="ListArrivingGoods"
          @showProduct="()=>{showRouter(item)}"
        /> -->
        <NewProductItem style="height: 100%;" :product="item" />
      </div>
      <iPagination
        v-if="dataList&&dataList.length"
        :current-page.sync="formData.pageindex"
        :limit.sync="formData.pagesize"
        :total-count="formData.totalCount"
        style="width: 1200px;"
        @turn="loadData"
      />
      <EmptyControl v-if="!dataList.length" style="margin: 20px 0; padding: 100px 0; width: 1200px;" type="goods" text="没有找到商品哦~" />
    </div>
    <iFooter />
  </div>
</template>

<script>
import iHeader from '@/components/Header'
import iNav from '@/components/Nav'
import iClassify from '@/components/Classify'
import iPageTitle from '@/components/PageTitle'
import iFooter from '@/components/Footer'
import iRightFixedBox from '@/components/RightFixedBox'
import ProductListItem from '@/components/ProductListItem'
import { BaseMixin } from '../../mixins/BaseMixin'
import { CollectType } from '@/dictionary/goods.js'
import NewProductItem from '../../views/storey/NewProductItem.vue'

export default {
  components: {
    iHeader,
    iNav,
    iFooter,
    iRightFixedBox,
    iClassify,
    iPageTitle,
    ProductListItem,
    NewProductItem
  },
  mixins: [BaseMixin],
  data() {
    return {
      pageTitle: ['即将到货'],
      dataList: [],
      advertList: [],
      dataIdList: [],
      Enum_CollectType: CollectType.Subscribe,
      dataState: {
        // 刷新中
        refreshing: false,
        // 加载中
        loading: false
      },
      // 请求参数
      formData: {
        Offset: 1,
        pagesize: 10,
        isArriving: true,
        totalCount: 0,
        keyword: ''
      },
      IsHasNext: false,
      url: {
        getNewGoodsList: '/api_goods/GoodsSku/ListForCustomerV3', // 即将到货列表
        getAdvertisementInfos: '/api_basedata/HomePage/GetAdvertisementInfos?enumTerminalType=1&codes=ArrivingSoon', // 即将到货列表推荐广告图
        // 到货通知订阅数据
        getNoticeList: '/api_customer/CustomerCollect/GetListByBusinessId',
        // 到货通知
        SubNotice: '/api_customer/CustomerCollect/Create',
        // 取消订阅
        CancelSub: '/api_customer/CustomerCollect/PhysicalDeleteBatch'
      }
    }
  },
  mounted() {
    // 绑定监听页面滑动方法
    window.addEventListener('scroll', this.handleSearch)
  },
  created() {
    this.getAdvertisementInfos()
    this.loadData()
  },
  methods: {
    showRouter: function(item) {
      this._jump(this.Enum_LinkTypeCode.ProductDetails, item.Id, '_blank')
    },

    // 加载广告
    async getAdvertisementInfos() {
      const res = await this.getAction(`${this.url.getAdvertisementInfos}`)
      if (res.IsSuccess) {
        this.advertList = res.Data
        this.$refs['ActivityAdCarousel'].init(res.Data)
      }
    },
    serchHeald() {
      this.dataIdList = []
      this.dataList = []
      this.formData.Offset = 0
      this.loadData()
    },
    // 加载数据
    async loadData() {
      // 加载状态
      this.dataState.loading = true
      this.$hys.openLoading()
      const params = Object.assign({
        pageindex: this.formData.pageindex,
        pagesize: this.formData.pagesize
      },
      this.formData
      )
      const pros = await this.getAction(`${this.url.getNewGoodsList}`, params)
      this.$hys.clearLoading()
      if (!pros.IsSuccess) {
        this.$toast({ position: 'bottom', message: pros.Msg })
        return
      }
      // this.dataList = []
      // this.dataIdList = []
      this.formData.totalCount = pros.Count
      this.dataState.loading = false

      // 数据处理
      pros.Data.GoodsList.forEach(item => {
        item.img = this._showProductPicture(item.Logo)
        item.name = this._showProductTitle(item.SkuName, item.OperationName)
        item.Specifications
        item.subId = null
        this.dataList.push(item)
        this.dataIdList.push(item.Id)
      })
      this.IsHasNext = pros.Data.IsHasNext
      this.formData.Offset = pros.Data.Offset

      const notice = await this.postAction(
        `${this.url.getNoticeList}?collectType=` + this.Enum_CollectType,
        this.dataIdList
      )

      notice.Data.forEach(item => {
        const product = this.dataList.find(
          o => o.Id === item.CollectingBusinessId
        )
        product.subId = item.Id
      })
    },
    // 加载数据
    async onLoad() {
      await this.loadData()
    },
    /*
     * 监听页面滑动
     */
    handleSearch() {
      // 获取当前页面高度
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 获取网页可见区域高
      const clientHeight = document.body.clientHeight
      // 获取网页正文全文高
      const scrollHeight = document.body.scrollHeight

      // 当前页面高度大于指定位置时记录

      // 到达页面底部时
      if (scrollTop + clientHeight + 500 >= scrollHeight) {
        if (this.IsHasNext && this.dataState.loading === false) {
          this.loadData()
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .adlist {
    margin-left: calc((99vw - 1200px) / 2);
    padding-top: 20px;
    width: 1200px;
    max-width: 1200px;
  }

  .list {
    display: flex;
    margin-left: calc((99vw - 1200px) / 2);
    padding-bottom: 20px;
    width: 1200px;
    max-width: 1200px;
    flex-direction: row;
    // justify-content: space-between;
    flex-wrap: wrap;

    .list-item {
      float: left;
      padding-top: 20px;
      text-align: center;
    }
  }

  .searchBox {
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;

    /deep/.van-cell {
      margin-right: 50px;
      border: 2px solid rgba(15, 110, 233, 1);
      border-radius: 2px;
      padding: 0;
      padding-left: 20px;
      width: 400px;
      height: 40px;

      &::after {
        border: 0;
      }

      .van-button {
        border: 0;
        width: 100px;
        height: 40px;
        font-size: 18px;
        color: rgba(255, 255, 255, 1);
        background: rgba(15, 110, 233, 1);
      }
    }

    .search-text {
      margin-top: 10px;
      padding-right: 50px;

      ul li {
        display: inline-block;
        margin-right: 10px;

        >span {
          border-right: 1px solid #E5E5E5;
          padding-right: 10px;
          cursor: pointer;
        }

        &:last-child {
          margin-right: 0;

          >span {
            border-right: 0;
            padding-right: 0;
          }
        }
      }
    }
  }
</style>
